<template>
    <div class="tsbx">
        <div class="tsbxc">
            <div class="gritem" @click="go($event)" v-show="tp=='ts'">
                <div class="gileft">
                    <img src="../../assets/tsbx/tousu.png" alt="">
                    <span>投诉</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)" v-show="tp=='bx'&&!wyUser">
                <div class="gileft">
                    <img src="../../assets/tsbx/baoxiu.png" alt="">
                    <span>报修</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)" v-if="!wyUser">
                <div class="gileft">
                    <img src="../../assets/tsbx/pingjia.png" alt="">
                    <span>历史记录</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>

            <div class="gritem" @click="go($event)" v-if="!wyUser">
                <div class="gileft">
                    <img src="../../assets/tsbx/pingjia.png" alt="">
                    <span>评价</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>


                                   <div class="gritem" @click="go($event)" v-show="tp=='bx'&&wyUser&&wyUser.identityType!='9'">
                <div class="gileft">
                    <img src="../../assets/tsbx/gdcz.png" alt="">
                    <span>待派工单</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>



                        <div class="gritem" @click="go($event)" v-show="tp=='bx'&&wyUser">
                <div class="gileft">
                    <img src="../../assets/tsbx/gdbj.png" alt="">
                    <span>维修处理</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>



                        <div class="gritem" @click="go($event)" v-show="tp=='bx'&&wyUser">
                <div class="gileft">
                    <img src="../../assets/tsbx/zhcx.png" alt="">
                    <span>综合查询</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>


        </div>
    </div>
</template>
<script>
const axios = require('axios');
export default {
    data() {
        return {
            tp:'',
            wyUser:{}
        }
    },
    created () {

    },
    mounted() {
        this.wyUser=JSON.parse(localStorage.getItem('userInfo'))
        // console.log("🚀 ~ file: index.vue:59 ~ mounted ~ this.wyUser:", this.wyUser)
        if(this.$route.query.type == 'ts'){
            this.$route.meta.title = '投诉建议'
        }else{
            this.$route.meta.title = '报事报修'
        }
        this.tp = this.getidval('type')
    },
    methods: {
        getidval(name){    
            var url = window.location.href;
            console.log(url)
            let params = url.substr(url.lastIndexOf("?") + 1).split("&");
            for (let i = 0; i < params.length; i++) {
                let param = params[i];
                let key = param.split("=")[0];
                let value = param.split("=")[1];
                if (key === name) {
                return value;
                }
            }
        },

        go(event){
            var that =this
            var name = event.target.innerHTML
            if(name.indexOf('投诉') != -1){
                this.$router.push({ path: "/tsbx/tousu", query: {} });
            }
            if(name.indexOf('报修') != -1){
                 this.$router.push({ path: "/tsbx/baoxiu", query: {} });
            }
            if(name.indexOf('历史记录') != -1){
                 this.$router.push({ path: "/tsbx/list", query: {tp:this.tp} });
            }   
            if(name.indexOf('评价') != -1){
                 this.$router.push({ path: "/tsbx/pjlist", query: {tp:this.tp} });
            }   
            if(name.indexOf('待派工单') != -1){
                 this.$router.push({ path: "/tsbx/zplist", query: {tp:this.tp} });
            }   
            if(name.indexOf('维修处理') != -1){
                 this.$router.push({ path: "/tsbx/wxlist", query: {tp:this.tp} });
            }   
            if(name.indexOf('综合查询') != -1){
                 this.$router.push({ path: "/tsbx/wxzhlist", query: {tp:this.tp} });
            }   

             
        }
    },
}
</script>
<style lang="less">
    .tsbx{
        // height: 100%;
        width: 100%;
        display: flex;
        // background-color: #eeeeee;
        flex-direction: column;
        align-items: center;
        .tsbxc{
            width: calc(100% - 6%);
            .gritem{
                margin-top: 15px;
                height: 60px;
                width: 100%;
                display: flex;
                background: #fff;
                align-items: center;
                border-radius: 10px;
                justify-content: space-between;
                .gileft{
                    display: flex;
                    height: 100%;
                    align-items: center;
                    width: 50%;
                    img{
                        margin-left: 20px;
                    }
                    span{
                        margin-left: 10px;
                    }
                }
                .giright{
                    margin-right: 20px;
                    height: 100%;
                    align-items: center;
                    display: flex;
                    flex-direction:row-reverse;
                    img{
						display: block;
						height: 18px;
					}
                }
            }
        }
    }
</style>